import React, { useState, useEffect } from "react";
import withDashboard from "../../HOC/withDashboard";
import BackgroundImage from "../../assets/profilebackground.jpeg";
import "../Profile/index.css";
import { Button, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  getVirtualCardUserById,
  updateVirtualCardUser,
} from "../../services/VirtualCardServices";
import Loader from "../../components/Loader";
import { useNavigate, useParams } from "react-router-dom";
import { getFileUrl } from "../../services/CommonService";

const VirtualCardUserForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const [isLoading, setIsLoading] = React.useState(false);
  const [dataForm, setDataForm] = React.useState({});

  const isEdit = Boolean(id);
  const [form, setForm] = useState({
    rejectionReason: "",
    action: "",
  });
  const [errors, setErrors] = useState({
    rejectionReason: false,
    action: false,
  });

  const statusLabels = {
    pending: "Pending (Not Sent)",
    "pending-api-approval": "Pending API Approval",
    "api-rejected": "Rejected by API",
    "pending-admin-approval": "Pending Admin Approval",
    "admin-rejected": "Rejected by Admin",
    active: "Approved",
    suspended: "Suspended",
  };
  const statusOptionsLabels = {
    "admin-rejected": "Rejected by Admin",
    active: "Approved",
  };
  const apiStatusLabels = {
    pending: "Pending",
    rejected: "Rejected By Api",
    approved: "Approved by API",
  };

  useEffect(() => {
    getData(id);
  }, [id]);

  const getData = (id) => {
    setIsLoading(true);
    dispatch(getVirtualCardUserById(id))
      .then((res) => {
        console.log(res?.data?.data);

        setDataForm(res?.data?.data);
        setIsLoading(false);
      })
      .catch(({ message, errorData, statusCode }) => {
        console.error("Error fetching virtual card :", message);
        setIsLoading(false);
      });
  };

  const onChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: false });
  };
  const onSubmit = () => {
    let newErrors = "";
    if (
      form.action &&
      (form.action === "rejected" || form.action === "admin-rejected")
    ) {
      newErrors = {
        rejectionReason: !form.rejectionReason,
        action: !form.action,
      };
    } else {
      newErrors = {
        action: !form.action,
        rejectionReason: false,
      };
    }

    setErrors(newErrors);
    if (Object.values(newErrors).some((v) => v)) return;
    if (isEdit) {
      setIsLoading(true);
      dispatch(updateVirtualCardUser(id, form))
        .then((res) => {
          setIsLoading(false);
          navigate("/virtual-card-users");
        })
        .catch(({ message, errorData, statusCode }) => {
          console.error("Error updating virtual card :", message);
          setIsLoading(false);
        });
    }
  };

  return (
    <div className="profile-container">
      <div className="profile-backgroundImage-container">
        <img
          src={BackgroundImage}
          className="profile-backgroundImage"
          alt="background.png"
        />
      </div>
      <div className="profile-card-container">
        <div className="profile-card">
          <h2 style={{ marginBottom: 24 }}>
            {isEdit ? "Edit" : "Add"} Virtual Card User Data
          </h2>
          <div className="profile-inputs-container">
            <div className="profile-input-row">
              <table className="profile-table">
                <tbody>
                  <tr>
                    <th>ID</th>
                    <td>{dataForm._id || "N/A"}</td>
                  </tr>
                  <tr>
                    <th>User</th>
                    <td>
                      {dataForm?.userId?.name || "N/A"} (
                      {dataForm?.userId?.email || "N/A"})
                    </td>
                  </tr>
                  <tr>
                    <th>Card First Name</th>
                    <td>{dataForm.firstName || "N/A"}</td>
                  </tr>
                  <tr>
                    <th>Card Last Name</th>
                    <td>{dataForm?.lastName || "N/A"}</td>
                  </tr>
                  <tr>
                    <th>Card Email</th>
                    <td>{dataForm?.email || "N/A"}</td>
                  </tr>
                  <tr>
                    <th>Card Phone No</th>
                    <td>{dataForm?.phone || "N/A"}</td>
                  </tr>
                  <tr>
                    <th>Identity Id Type</th>
                    <td>{dataForm?.identity?.idType || "N/A"}</td>
                  </tr>
                  <tr>
                    <th>Identity BVN</th>
                    <td>{dataForm?.identity?.bvn || "N/A"}</td>
                  </tr>
                  <tr>
                    <th>Identity Id No</th>
                    <td>{dataForm?.identity?.idNo || "N/A"}</td>
                  </tr>
                  <tr>
                    <th>Identity Image</th>
                    <td>
                      {dataForm.identity?.selfieImage &&
                      dataForm.identity?.selfieImage !== "" ? (
                        <div className="user-image size-[50px] rounded-full ">
                          <img
                            src={getFileUrl(
                              dataForm.identity?.selfieImage,
                              "virtualCardImage"
                            )}
                            alt=""
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>Card Is Verified</th>
                    <td>{dataForm.isIdVerified ? "True" : "False"}</td>
                  </tr>{" "}
                  {dataForm.status &&
                  (dataForm.status === "rejected" ||
                    dataForm.status === "admin-rejected") ? (
                    <tr>
                      <th>Reject Note</th>
                      <td>{dataForm.rejectionReason || "N/A"}</td>
                    </tr>
                  ) : (
                    <></>
                  )}
                  <tr>
                    <th>Status</th>
                    <td>{statusLabels[dataForm.status] || "Unknown Status"}</td>
                  </tr>
                  <tr>
                    <th>API Status</th>
                    <td>
                      {apiStatusLabels[dataForm.apiStatus] || "Unknown Status"}
                    </td>
                  </tr>
                  <tr>
                    <th>API Rejection Error</th>
                    <td>{dataForm.apiRejectionReason || "Unknown Error"}</td>
                  </tr>
                  {dataForm.status && dataForm.status !== "active" ? (
                    <>
                      <tr>
                        <td colSpan={2}>
                          <div className="profile-input-item">
                            <div className="profile-input-container">
                              <TextField
                                select
                                label="Action"
                                variant="outlined"
                                className="w-100"
                                name="action"
                                onChange={onChange}
                                value={form.action}
                                error={errors.action}
                                helperText={
                                  errors.action ? "Action is required" : ""
                                }
                                SelectProps={{
                                  native: true,
                                }}
                              >
                                <option value="">Select Action</option>
                                {Object.entries(statusOptionsLabels).map(
                                  ([value, label]) => (
                                    <option key={value} value={value}>
                                      {label}
                                    </option>
                                  )
                                )}
                              </TextField>
                            </div>
                          </div>
                        </td>
                      </tr>{" "}
                      {form.action &&
                      (form.action === "rejected" ||
                        form.action === "admin-rejected") ? (
                        <tr>
                          <td colSpan={2}>
                            <div className="profile-input-item">
                              <div className="profile-input-container">
                                <TextField
                                  label="Rejection Note"
                                  variant="outlined"
                                  className="w-100"
                                  name="rejectionReason"
                                  onChange={onChange}
                                  value={form.rejectionReason}
                                  error={errors.rejectionReason}
                                  helperText={
                                    errors.rejectionReason
                                      ? "Rejection Note is required"
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </td>
                        </tr>
                      ) : (
                        <></>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </tbody>
              </table>
            </div>{" "}
            <div className="profile-input-btn-container">
              {dataForm.status && dataForm.status !== "active" ? (
                <Button
                  variant="contained"
                  className="profile-btn"
                  onClick={onSubmit}
                  disabled={isLoading}
                >
                  Update
                </Button>
              ) : (
                <></>
              )}

              <Button
                variant="outlined"
                style={{ marginLeft: 16 }}
                onClick={() => navigate("/virtual-card-users")}
              >
                Cancel
              </Button>
            </div>
          </div>
          {isLoading && <Loader />}
        </div>
      </div>
    </div>
  );
};

export default withDashboard(VirtualCardUserForm);
